// removed by extract-text-webpack-plugin
module.exports = {"cell":"SubjectsListPage__cell___3wrPg","isNotTreatmentAdherent":"SubjectsListPage__isNotTreatmentAdherent___3H8L8","archived":"SubjectsListPage__archived___fMKcQ"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/pages/SubjectsListPage.css
// module id = 1213
// module chunks = 0